export const LHR_BUILD_TYPE = 'lhr-build-type';
export const NEW_LHR_BUILD_TYPE = 'new-lhr-build-type';
